module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook.b6232870.webp";